module.exports = __webpack_public_path__ + "img/PPMP36.ab3111e5.png";